import templateUrl from './deviceMicroPortalViewer.html';
import controller from './deviceMicroPortalViewer.controller';

const deviceMicroPortalViewerComponent = {
	templateUrl,
	controller
};

export default deviceMicroPortalViewerComponent;
